export const ALL_OUTCOMES = ['ok', 'issue', 'na', 'unable'];
/** Files step: «Ошибок нет» / «Есть ошибки» / «Не делали». */
export const FILES_OUTCOMES = ['ok', 'issue', 'na'];
/** Conditions are always answered — there is nothing to fail or skip. */
export const RECORD_ONLY_OUTCOMES = ['ok'];
const COMBUSTION = ['petrol', 'diesel', 'hybrid'];
/** EV → the step is automatically «Не применимо». */
export const NOT_EV = { fuel: COMBUSTION };
export const photos = (min, category) => ({
    kind: 'photo',
    min,
    category,
});
export const video = (maxDurationSec, category) => ({
    kind: 'video',
    min: 1,
    category,
    maxDurationSec,
});
export const NO_CAPTURE = { kind: 'none', min: 0, category: 'exterior' };
export const FILES_CAPTURE = { kind: 'file', min: 0, category: 'diagnostics' };
/** Recorder limits per video step, seconds (mockup: «Холодный пуск» 00:15). */
export const VIDEO_SECONDS = { coldStart: 15, exhaust: 15, engineRunning: 30 };
export const ZONES_FRONT = [
    'bumper_front',
    'hood',
    'grille',
    'headlight_left',
    'headlight_right',
    'fender_front_left',
    'fender_front_right',
    'glass_windshield',
];
export const ZONES_LEFT = [
    'fender_front_left',
    'door_front_left',
    'door_rear_left',
    'fender_rear_left',
    'sill_left',
    'mirror_left',
    'glass_front_left',
    'glass_rear_left',
    // AUT-413 — the side view draws the pillars, so the side step offers them.
    // WIDENED, not moved: the roof step keeps them too (a draft that already
    // carries a pillar on «Крыша» must keep PATCHing — validate.zones), and the
    // api must deploy before the app, or it 400s a left-step pillar.
    'pillar_a_left',
    'pillar_b_left',
    'pillar_c_left',
];
export const ZONES_RIGHT = [
    'fender_front_right',
    'door_front_right',
    'door_rear_right',
    'fender_rear_right',
    'sill_right',
    'mirror_right',
    'glass_front_right',
    'glass_rear_right',
    'pillar_a_right',
    'pillar_b_right',
    'pillar_c_right',
];
export const ZONES_REAR = [
    'bumper_rear',
    'trunk_lid',
    'glass_rear',
    'taillight_left',
    'taillight_right',
    'fender_rear_left',
    'fender_rear_right',
];
export const ZONES_GLASS = [
    'glass_windshield',
    'glass_rear',
    'glass_front_left',
    'glass_front_right',
    'glass_rear_left',
    'glass_rear_right',
];
export const ZONES_LIGHTS = [
    'headlight_left',
    'headlight_right',
    'taillight_left',
    'taillight_right',
];
/** Rails, strut towers and the radiator support («телевизор») — where front impacts show. */
export const ZONES_ENGINE_BAY = [
    'frame_rail_left',
    'frame_rail_right',
    'strut_tower_left',
    'strut_tower_right',
    'radiator_support',
    'hood',
];
export const ZONES_TRUNK = [
    'trunk_lid',
    'bumper_rear',
    'trunk_floor',
    'spare_wheel_well',
];
/** Pillars A/B/C — a repainted pillar is the classic rollover sign. */
export const ZONES_PILLARS = [
    'pillar_a_left',
    'pillar_a_right',
    'pillar_b_left',
    'pillar_b_right',
    'pillar_c_left',
    'pillar_c_right',
];
export const ZONES_OPENINGS = ['sill_left', 'sill_right', ...ZONES_PILLARS];
export const ZONES_WHEELS_FRONT = ['wheel_front_left', 'wheel_front_right'];
export const ZONES_WHEELS_REAR = ['wheel_rear_left', 'wheel_rear_right'];
export const ZONES_UNDERBODY = [
    'underbody_front',
    'underbody_rear',
    'suspension_front',
    'suspension_rear',
    'exhaust',
];
//# sourceMappingURL=catalogue.v1.parts.js.map